import React, {useEffect} from 'react'
import { useLocation } from 'react-router-dom'
import ReactPlayer from 'react-player'
import { useResultContext } from '../context/ResultContextProvider'
import { Loading } from './Loading'

export const Results = () => {

    const {results,isLoading, getResults, searchWord} = useResultContext();

    const location = useLocation(); // gives URL
    console.log(results)
    console.log(searchWord);
    // useEffect(() => {
    //     if(searchWord)
    //     {
    //         if(location.pathname === '/videos')
    //             getResults(`/search/q=${searchWord} videos`)
    //     }
    //     else{

        
    //     getResults(`${location.pathname}/q=${searchWord}`)
    //     }
        
    // }, [searchWord,location.pathname,getResults]);


    useEffect(() => {
        if(searchWord){
            if(location.pathname === '/videos'){
                getResults(`/search/q=${searchWord} videos&num=30`)
            }
        

        else
        getResults(`${location.pathname}/q=${searchWord}&num=50`)
        }   
    }, [searchWord,location.pathname]);

    if(isLoading) 
    return <Loading/>

    // based on /type we write switch statemtns and put asssociated results

    console.log(location.pathname)
    switch (location.pathname) {
        case '/search':
            return (
                <div className="flex justify-between flex-wrap space-y-5 sm:px-50">
                      {/* information on link and title as param is obtained from RapidAPi 
                      "results":[97 items
0:{3 items
"description":"Signature. Elon Reeve Musk FRS (/ˈiːlɒn/; born June 28, 1971) is an engineer, industrial designer, technology entrepreneur and philanthropist."
"link":"https://en.wikipedia.org/wiki/Elon_Musk"
"title":"Elon Musk - Wikipedia" */}
                        {/*results?.*/results?.map(({link,title},index)=> (
                                <div key={index} className="md:w-2/5 w-full">
                                    <a href={link} target="_blank" rel="noref">
                                        <p className="text-sm">
                                            
                                            {link.length>30 ? link.substring(0,30) :link}
                                            
                                        </p>
                                        <p className="text-lg hover:underline dark:text-blue-300 text-blue-600">
                                            {title}
                                        </p>
                                    </a>
                                </div>
                        ))}

                        
                </div>
            )
            
        case '/images':
            return(
                <div className="flex flex-wrap justify-center items-center sm:justify-center sm:items-center">
                    {results?.map(({image,link:{href,title}},index)=> (
                        <a className="sm:p-3 p-5" href={href} key={index} target="_blank" rel="noref">
                            <img src={image?.src} alt={title} loading="lazy"/>

                            <p className="w-50 break-words text-sm mt-2">
                                {title}
                            </p>
                        </a>
                    
                    ))}
                </div>
            )
        
                
        case '/news':
            return (
                <div className="flex justify-between flex-wrap space-y-5 sm:px-50 items-center">
                    
                        {results?.map(({links,id,source,title})=> (
                                <div key={id} className="md:w-2/5 w-full">
                                    <a href={links?.[0].href} target="_blank" rel="noref" className="hover:underline">
                                    
                                        <p className="text-lg  dark:text-blue-300 text-blue-600">
                                            {title}
                                        </p>
                                        <div className="flex gap-5">
                                        <a href={source?.href} target="_blank" rel="noref">

                                            {source?.href}

                                        </a>

                                        </div>
                                    </a>
                                </div>
                        ))}

                        
                </div>
            )
               

        case '/videos':
            return (
                <div className="flex flex-wrap">
                
                    {results.map((video,index) =>(
                        <div key={index} className="p-4">
                           <ReactPlayer url={video.additional_links?.[0].href} controls width="400px" height="200px" />
                        </div>
                    ))

                    }

                </div>
            )
            
    
        default:
            return 'ERROR!';
    }
}
